import { sha512 } from '../sha512';
import assert from 'nanoassert';

if (new Uint16Array([1])[0] !== 1)
  throw new Error('Big endian architecture is not supported.');

export const crypto_hash_sha512_BYTES = 64;
export const crypto_hash_BYTES = crypto_hash_sha512_BYTES;

export function crypto_hash_sha512(out, m, n) {
  assert(
    out.byteLength === crypto_hash_sha512_BYTES,
    'out must be crypto_hash_sha512_BYTES bytes long'
  );

  sha512().update(m.subarray(0, n)).digest(out);
  return 0;
}

export function crypto_hash(out, m, n) {
  return crypto_hash_sha512(out, m, n);
}
